import { render } from "./ShortEmptyMessage.vue?vue&type=template&id=4233d744&scoped=true"
const script = {}

import "./ShortEmptyMessage.vue?vue&type=style&index=0&id=4233d744&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4233d744"]])

export default __exports__